<template>
  <div class="findPassWord">
    <Header></Header>
    <div id="description">
      <div class="w">找回密码</div>
    </div>
    <div class="container">
      <div class="w">
        <div class="content">
          <div class="stepBar">
            <ul class="step clearfix">
              <li class="l s1">
                <img :src="step1" />
                <p style="color:#3eda91">填写账户名</p>
              </li>
              <li class="l s2">
                <img :src="step2" />
                <p>验证身份</p>
              </li>
              <li class="l s3">
                <img :src="step3" />
                <p>设置新密码</p>
              </li>
              <li class="s4">
                <img :src="step4" />
                <p></p>
              </li>
            </ul>
            <div class="step-con">
              <div class="item" style="display: block">
                <div class="first">
                  账户名
                  <input
                    type="text"
                    maxlength="11"
                    v-model="ruleForm.mobile"
                    placeholder="请输入您的手机号"
                  />
                </div>
              </div>
              <div class="item">
                <div class="message first">
                  <i></i> 已发送动态码到您的手机！
                </div>
                <div>
                  手机校证码
                  <input type="text" v-model="ruleForm.code" placeholder="请输入验证码" />
                </div>
              </div>
              <div class="item three">
                <div class="first">
                  设置新密码
                  <input type="text" v-model="ruleForm.password" placeholder="请输入您的新密码" />
                </div>
                <div>
                  &nbsp;&nbsp;确认密码
                  <input
                    class="affPwd"
                    v-model="newPassword"
                    type="text"
                    placeholder="请再次输入您的新密码"
                  />
                </div>
              </div>
              <div class="item reset-end">
                <div class="message-success">
                  <i></i> 恭喜您，密码修改成功，快去登录吧！
                </div>
              </div>
              <div class="nextStep">
                <button class="nextBtn" @click="handelClick()">下一步</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '../components/common/Header'
import Fotter from '../components/common/Fotter'

export default {
  name: 'findPassWord',
  data() {
    return {
      active: 0,
      step1: require('../assets/images/step01-active.png'),
      step2: require('../assets/images/step02.png'),
      step3: require('../assets/images/step03.png'),
      step4: require('../assets/images/step04.png'),
      ruleForm: {
        mobile: '',
        code: '',
        password: ''
      },
      newPassword: '',
      flag: false
    }
  },
  components: {
    Header,
    Fotter
  },
  methods: {
    async handelClick() {
      this.flag = false
      if (this.active == 0) {
        let reg = /^[1][3,4,5,7,8][0-9]{9}$/
        if (reg.test(this.ruleForm.mobile)) {
          let param = new URLSearchParams()
          param.append('mobile', this.ruleForm.mobile)
          param.append('event', 'resetpwd')
          const { data: res } = await this.$http.post('/api/sms/send', param)
          if (res.code == 1) {
            this.flag = true
          } else {
            this.$confirm('验证码发送频繁,请联系客服', '提示')
          }
        } else {
          this.$confirm('请输入合法的手机号码', '提示')
        }
      } else if (this.active == 1) {
        let params = new URLSearchParams()
        params.append('mobile', this.ruleForm.mobile)
        params.append('event', 'resetpwd')
        params.append('captcha', this.ruleForm.code)
        const { data: result } = await this.$http.post('/api/sms/check', params)
        if (result.code) {
          this.flag = true
        } else {
          this.$confirm(result.msg, '提示')
        }
      } else if (this.active == 2) {
        if (this.ruleForm.password == this.newPassword) {
          let param = new URLSearchParams()
          param.append('mobile', this.ruleForm.mobile)
          param.append('type', 'mobile')
          param.append('captcha', this.ruleForm.code)
          param.append('newpassword', this.ruleForm.password)
          const { data: res } = await this.$http({
            method: 'post',
            url: '/api/user/resetpwd',
            data: param
          })
          if (res.code == 1) {
            this.flag = true
            this.$confirm('修改成功', '提示')
          } else {
            this.$confirm(res.msg, '提示')
          }
        } else {
          this.$confirm('密码不一致', '提示')
        }
      } else {
        this.$router.push('/login')
      }
      if (this.flag) {
        this.active += 1
        $('.item')
          .eq(this.active)
          .css('display', 'block')
          .siblings('.item')
          .css('display', 'none')
        if (this.active == 1) {
          this.step2 = require('../assets/images/step02-active.png')
          $('.s2 p').css('color', '#3eda91')
        } else if (this.active == 2) {
          this.step3 = require('../assets/images/step03-active.png')
          $('.s3 p').css('color', '#3eda91')
        } else if (this.active == 3) {
          this.step4 = require('../assets/images/step04-active.png')
          $('.s4 p').html('设置成功')
          $('.s4 p').css({
            color: '#3eda91',
            'font-size': '18px',
            'margin-top': '10px',
            'text-align': 'center'
          })
          $('.nextBtn').html('立即登录')
        } else if (this.active == 4) {
          this.$router.push('/login')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.findPassWord {
  #description {
    background-color: #eef2f5;
    font-size: 22px;
    height: 60px;
    line-height: 60px;
  }
  .container {
    height: 600px;
    width: 100%;
    background-color: #fff;
    .content {
      padding: 50px 158px 0 158px;
      .stepBar {
        .step {
          margin-bottom: 45px;
          .l {
            float: left;
            text-align: center;
            font-size: 18px;
            p {
              margin-top: 10px;
            }
          }
        }
        .step-con .item:nth-child(2) div:nth-child(2) {
          position: relative;
          width: 390px;
          button {
            position: absolute;
            top: 9px;
            right: 10px;
            width: 88px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #dbfced;
            color: #3eda91;
          }
        }
        .step-con {
          .item {
            display: none;
            .first {
              margin-bottom: 15px;
            }
            .code-box {
              position: relative;
            }
            div {
              width: 360px;
              height: 45px;
              line-height: 45px;
              margin: auto;
              font-size: 14px;
              color: #666;
              input {
                box-sizing: border-box;
                width: 300px;
                height: 40px;
                outline: none;
                font-size: 14px;
                color: #666;
                border-radius: 5px;
                box-shadow: -1px 0px 10px 2px #eef9f4;
                border: 1px solid #eee;
                margin-left: 11px;
                padding-left: 10px;
              }
              .veri-code {
                position: absolute;
                top: 8px;
                right: 8px;
                width: 88px;
                height: 32px;
                background: url(../assets/icons/ver-code.png) no-repeat;
              }
            }
            .message {
              font-size: 22px;
            }
            .message i {
              display: inline-block;
              width: 48px;
              height: 48px;
              background: url(../assets/icons/info.png);
              vertical-align: middle;
              margin-right: 10px;
            }
            .message-success {
              width: 440px;
              height: 50px;
              font-size: 22px;
              color: #747474;
              i {
                display: inline-block;
                width: 48px;
                height: 48px;
                background: url(../assets/icons/success.png);
                vertical-align: middle;
                margin-right: 10px;
              }
            }
          }
          .three div {
            width: 390px;
          }
          .three {
            div:nth-child(2) input {
              margin-left: 17px;
            }
          }
          .nextStep {
            width: 180px;
            height: 42px;
            margin: auto;
            margin-top: 40px;
            .nextBtn {
              width: 180px;
              height: 42px;
              line-height: 42px;
              background-color: #3eda91;
              color: #fff;
              font-size: 16px;
              text-align: center;
              border-radius: 5px;
              margin: auto;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
